import {mapGetters} from "vuex";

const mixin = {
    data() {
        return {
            formChanged: false
        }
    },
    methods: {
        beforeWindowUnload(e) {
            if (this.hasUnsavedForm) {
                e.preventDefault()
                e.returnValue = ''
            }
        },
    },
    computed:{
        ...mapGetters({
            hasUnsavedForm: 'profile/hasUnsavedForm',
        })
    },
    beforeRouteLeave(to, from, next) {
        if (this.hasUnsavedForm) {
            const answer = window.confirm(this.trans('profile.confirm_leave_page'))
            if (answer) return next()
            next(false)
        } else {
            next()
        }
    },
    created() {
        window.addEventListener('beforeunload', this.beforeWindowUnload)
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },
}

export default mixin